import { assertNotEmpty, type Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useTemplateContext } from '../../context/templateContext'
import type { ModelMetaType } from '../../types/metaModel'
import type { TemplateReferenceValueSetupField } from '../../types/templateModel'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'

export const useUnusedTemplateReferences = (
  field: TemplateReferenceValueSetupField,
) => {
  const { templateVersion } = useTemplateContext()
  const { applicationTemplates: applicationTemplateOperations } =
    useApplicationViewOperationsContext()

  assertNotEmpty(templateVersion)

  const typedOriginalPropertyType =
    field.originalPropertyType as Optional<ModelMetaType>

  const matchableTypeNames = useMemo(
    () =>
      typedOriginalPropertyType
        ? [
            typedOriginalPropertyType.templateTypeName,
            ...(typedOriginalPropertyType.templateType?.subTypeNames ?? []),
          ]
        : [],
    [typedOriginalPropertyType],
  )

  return useMemo(() => {
    const availableVariantsIds = (field.value?.variants ?? []).map(
      (v) => v.source,
    )

    return [...(applicationTemplateOperations?.values() ?? [])]
      .filter(
        (templateOperations) =>
          templateOperations.lastEntity &&
          matchableTypeNames.includes(
            templateOperations.lastEntity.templateTypeName,
          ) &&
          !availableVariantsIds.includes(templateOperations.templateId),
      )
      .map((createOperations) => createOperations.templateId)
      .sort()
  }, [field.value?.variants, matchableTypeNames, applicationTemplateOperations])
}
